import {
  cargoSubtype,
  transportCategory,
  TransportCategory,
  useResolveTicketAppPreferenceProfileQuery
} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {skipToken} from "@reduxjs/toolkit/query";
import {ContainerSelect, ContainerSelectProps} from "./ContainerSelect";

type ContainerCargoSubtypeProps = {
  regionId?: string;
  category: TransportCategory;
  companyId?: string;
  siteId?: string;
  containerId?: string;
  freightTypeId?: string;
  serviceTypeId?: string;
};

const useContainerCargoSubtype = (props: ContainerCargoSubtypeProps) => {
  const {
    regionId,
    category,
    companyId,
    siteId,
    containerId,
    freightTypeId,
    serviceTypeId
  } = props;

  const preferenceProfileArg = useMemo(() => {
    if (!regionId || !companyId) {
      return skipToken;
    }

    return {
      category: category.code,
      regionId: regionId,
      companyId: companyId,
      siteId: siteId,
      containerId: containerId,
      freightTypeId: freightTypeId,
      serviceTypeId: serviceTypeId,
    };
  }, [
    category.code,
    companyId,
    containerId,
    freightTypeId,
    regionId,
    serviceTypeId,
    siteId
  ]);

  const {data: preferenceProfile} = useResolveTicketAppPreferenceProfileQuery(preferenceProfileArg);

  return preferenceProfile?.allowAnyContainerSelection
    ? undefined
    : category === transportCategory.oil ? cargoSubtype.oil : undefined;
};

export type PreferenceAwareContainerSelectProps = Omit<ContainerSelectProps, "selector"> & ContainerCargoSubtypeProps;

export const PreferenceAwareContainerSelect = (props: PreferenceAwareContainerSelectProps) => {
  const {
    regionId,
    category,
    companyId,
    siteId,
    containerId,
    freightTypeId,
    serviceTypeId,
    ...rest
  } = props;

  const containerCargoSubtype = useContainerCargoSubtype({
    regionId,
    category,
    companyId,
    siteId,
    containerId,
    freightTypeId,
    serviceTypeId
  });

  return (
    <ContainerSelect
      {...rest}
      selector={{
        regionId: regionId,
        siteId: siteId,
        cargoSubtype: containerCargoSubtype,
      }} />
  );
};
